// @ts-nocheck

// import posthog from "posthog-js";
import { useEffect, useState } from "react";

function DebugLog(log) {
    const [debugMode, setDebugMode] = useState(false)
    const [logEntries, setLogEntries] = useState([]);

    useEffect(( ) => {
        console.log(log)
        // posthog.capture("user_sent_data", {"debug": JSON.stringify(log)});
        setLogEntries([
          // with a new array
          ...logEntries, // that contains all the old items
          log, // and one new item at the end
        ]);
    }, [log])
    useEffect(() => {
      if (localStorage.getItem("debugMode")) {
        const mode = localStorage.getItem("debugMode");
        if (mode) {
          setDebugMode(JSON.parse(mode));
        }
        // if (authRaw) {
        //   const auth = JSON.parse(authRaw);
        //   const id = auth["id"];
        //   setUserID(id);
        // }z
      }
    }, [localStorage]);
  return (
    debugMode && (
      <div className="absolute bottom-20 w-full ">
        <div className="mockup-code w-full">
          {logEntries.map((item) => (
            <pre data-prefix=">">
              <code>{JSON.stringify(item)}</code>
            </pre>
          ))}
        </div>
      </div>
    )
  );
}

export default DebugLog;
